export default __webpack_public_path__ + "static/media/percent.b17f5600.svg";